var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSafeRequired(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 77,
    viewBox: "0 0 76 77",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.599976,
    width: 76,
    height: 76,
    rx: 8,
    fill: "#FCEBE3"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_401_386)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_401_386)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.5469 29.1557L44.6261 17.6016L52.7386 23.6245L49.7886 29.2786L34.5469 29.1557Z",
    fill: "#02475E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.3525 29.1478L36.2828 17.1406L47.7002 21.4475L42.6402 29.2783L31.3525 29.1478Z",
    fill: "#02475E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.0775 34.5602H16.6025V38.9852H18.0775V34.5602Z",
    fill: "#F78670"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.0605 29.6437L43.8939 16.6145C44.0168 16.3686 44.3856 16.3686 44.6314 16.4916L53.8502 23.3749C54.096 23.4978 54.096 23.8666 53.9731 24.1124L49.7939 29.3978C49.671 29.5207 49.5481 29.6437 49.4252 29.6437H48.3189L50.7772 26.3249C49.4252 25.3416 49.0564 23.3749 50.1627 21.8999L46.9668 19.4416C46.721 19.3187 46.4752 19.3187 46.3522 19.5645C45.4918 20.302 44.2626 20.5478 43.2793 20.0562C43.0335 19.9332 42.7876 19.9332 42.6647 20.1791L35.6585 29.5207C35.5355 29.6437 35.4126 29.7666 35.2897 29.7666H34.0605V29.6437Z",
    fill: "#02475E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.9772 29.6436C38.9772 29.3977 38.9772 29.1519 39.1001 28.9061L38.4855 28.4144L38.9772 27.7998L39.5918 28.2915C39.8376 28.0456 40.2064 27.9227 40.4522 27.9227C40.821 27.9227 41.1897 28.0456 41.4355 28.2915C41.4355 28.2915 41.4355 28.2915 41.5585 28.4144L41.0668 29.029C40.9439 28.9061 40.698 28.9061 40.5751 28.9061C40.4522 28.9061 40.2064 29.029 40.0835 29.1519C39.9605 29.3977 39.8376 29.5206 39.9605 29.7665H41.9272L42.173 29.6436C42.5418 29.5206 42.7876 29.5206 43.0335 29.6436C43.1564 29.6436 43.1564 29.7665 43.2793 29.7665H45.3689C45.246 28.7831 44.7543 27.9227 43.8939 27.1852C42.173 25.9561 39.7147 26.2019 38.4855 27.9227C38.1168 28.4144 37.871 29.029 37.748 29.6436H38.9772Z",
    fill: "#02475E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.6406 58.8939H28.2781V60.0002C28.2781 60.3689 27.9094 60.7377 27.5406 60.7377H22.3781C22.0094 60.7377 21.6406 60.3689 21.6406 60.0002V58.8939V58.8939Z",
    fill: "#F78670"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.1668 27.5579L31.4752 27.6808C31.2293 28.5412 30.4918 29.2787 30.3689 29.6474H21.7647H21.396V30.0162V56.5662V56.9349H21.7647H57.1648H57.5335V56.5662V30.0162V29.6474H57.1648H49.5478C51.0228 27.6808 50.6828 28.1648 51.3262 27.4349H56.3044C57.9023 27.4349 59.2544 28.787 59.2544 30.3849V55.7058C59.2544 57.5495 57.7794 59.0245 55.9356 59.0245H20.1668C18.5689 59.0245 17.2168 57.6724 17.2168 56.0745V52.7558H18.8147V46.6099H17.2168V39.8495H18.8147V33.7037H17.2168V30.5079C17.2168 28.787 18.446 27.5579 20.1668 27.5579Z",
    fill: "#F78670"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.8532 34.0724V37.2683C45.6074 37.2683 45.4844 37.2683 45.2386 37.2683C44.9928 37.2683 44.7469 37.2683 44.624 37.2683V34.0724C44.624 33.212 45.8532 33.212 45.8532 34.0724Z",
    fill: "#F78670"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.6734 30.382H22.1338V56.1945H56.6734V30.382Z",
    fill: "#F78670"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.1963 58.8939H54.8338V60.0002C54.8338 60.3689 54.465 60.7377 54.0963 60.7377H48.9338C48.565 60.7377 48.1963 60.3689 48.1963 60.0002V58.8939Z",
    fill: "#F78670"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.0775 47.4665H16.6025V51.8915H18.0775V47.4665Z",
    fill: "#F78670"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.2647 48.5766L48.5605 46.9787C48.6835 46.8558 48.8064 46.6099 48.9293 46.487C49.0522 46.2412 49.1751 46.1183 49.1751 45.8724L51.8793 47.4704C52.6168 47.962 52.0022 49.0683 51.2647 48.5766Z",
    fill: "#02475E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.2423 37.8828C48.3152 37.8828 50.6507 40.3411 50.6507 43.2911C50.6507 46.2411 48.1923 48.6995 45.2423 48.6995C42.2923 48.6995 39.834 46.2411 39.834 43.2911C39.834 40.3411 42.2923 37.8828 45.2423 37.8828Z",
    fill: "#02475E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.2425 39.8418C47.2091 39.8418 48.6841 41.4397 48.6841 43.2835C48.6841 45.2501 47.0862 46.7251 45.2425 46.7251C43.2758 46.7251 41.8008 45.1272 41.8008 43.2835C41.8008 41.3168 43.2758 39.8418 45.2425 39.8418Z",
    fill: "#F78670"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.8793 39.6779L49.1751 41.2758C49.0522 41.03 49.0522 40.9071 48.9293 40.6612C48.8064 40.4154 48.6835 40.2925 48.5605 40.1696L51.2647 38.5717C52.0022 38.2029 52.6168 39.3092 51.8793 39.6779Z",
    fill: "#02475E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.3577 38.5717L41.0618 40.1696C40.9389 40.2925 40.816 40.5383 40.6931 40.6612C40.5702 40.9071 40.4472 41.03 40.4472 41.2758L37.7431 39.6779C37.0056 39.3092 37.6202 38.2029 38.3577 38.5717Z",
    fill: "#02475E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.87 47.4704L40.5742 45.8724C40.6971 46.1183 40.6971 46.2412 40.82 46.487C40.943 46.7329 41.0659 46.8558 41.1888 46.9787L38.4846 48.5766C37.7471 49.0683 37.1325 47.962 37.87 47.4704Z",
    fill: "#02475E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.624 51.7656V48.5698C44.8699 48.5698 44.9928 48.5698 45.2386 48.5698C45.4844 48.5698 45.7303 48.5698 45.8532 48.5698V51.7656C45.8532 52.626 44.624 52.626 44.624 51.7656Z",
    fill: "#02475E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.8532 34.8022V37.9981C45.6074 37.9981 45.4844 37.9981 45.2386 37.9981C44.9928 37.9981 44.7469 37.9981 44.624 37.9981V34.8022C44.624 33.9418 45.8532 33.9418 45.8532 34.8022Z",
    fill: "#02475E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.8698 29.6436H56.0573C56.6719 29.6436 57.2865 30.1352 57.2865 30.8727V55.4561C57.2865 56.0706 56.7948 56.6852 56.0573 56.6852H22.8698C22.2552 56.6852 21.6406 56.1936 21.6406 55.4561V30.8727C21.7635 30.2581 22.2552 29.6436 22.8698 29.6436Z",
    stroke: "#F78670",
    strokeWidth: 2.2125,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.4883 28.6251L35.6508 16.9613C35.7737 16.7348 36.0195 16.6216 36.2654 16.7348L42.1654 18.9996L41.4279 19.7923L39.2154 18.9996C38.9695 18.8864 38.7237 18.9996 38.6008 19.2261C37.9862 20.132 36.88 20.585 35.7737 20.3585C35.5279 20.3585 35.282 20.3585 35.282 20.585L31.7175 28.6251L31.5945 28.7384H30.4883V28.6251Z",
    fill: "#02475E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.6025 34.0695H18.2005C18.3234 34.0695 18.4463 34.1924 18.4463 34.3153V39.232C18.4463 39.3549 18.3234 39.4778 18.2005 39.4778H16.6025",
    stroke: "#02475E",
    strokeWidth: 1.475,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.6025 46.9757H18.2005C18.3234 46.9757 18.4463 47.0986 18.4463 47.2215V52.1382C18.4463 52.2611 18.3234 52.384 18.2005 52.384H16.6025",
    stroke: "#02475E",
    strokeWidth: 1.475,
    strokeMiterlimit: 10
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_401_386"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 59,
    height: 59,
    fill: "white",
    transform: "translate(8 9.00037)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_401_386"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 42.6521,
    height: 44.3729,
    fill: "white",
    transform: "translate(16.6045 16.3754)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSafeRequired);
export default __webpack_public_path__ + "static/media/SafeRequired.1c77a5ed454a261cf6ed8e7216433854.svg";
export { ForwardRef as ReactComponent };